import axios from 'axios';

export interface IAssistantResponse {
  text: string;
}

let baseUrl = '';
let getToken: (() => string | null | undefined) | null = null;

export default class AssistantQueryService {
  static configure(
    url: string,
    options?: { getToken?: () => string | null | undefined },
  ): void {
    baseUrl = url;

    if (options?.getToken) {
      getToken = options.getToken;
    }
  }

  private static authConfig(extra: any = {}): any {
    const token = getToken?.();

    if (!token) {
      return extra;
    }

    return {
      ...extra,
      headers: { ...(extra.headers || {}), Authorization: `Bearer ${token}` },
    };
  }

  static async queryAssistant(config: any = {}): Promise<IAssistantResponse> {
    const { data } = await axios.post(
      `${baseUrl}api/v2/assistant/query/model`,
      { ...config },
      this.authConfig(),
    );

    return data;
  }
}
